<template>
  <div>
    <div class="jf-activity-bgcon jf-activity-bgcon--style jf-activity-bgcon--icon" :style="`background:#fef4dd`">
      <div v-if="isShowTabs" class="jf-activity-tab">
        <span :class="{ active: activeTab === 'coupon' }" @click="() => (activeTab = 'coupon')">皮肤优惠</span>
        <template v-for="item in activityGoods">
          <span v-if="item.name" :key="item.name" :class="{ active: activeTab === item.name }" @click="() => (activeTab = item.name)">{{
            item.name
          }}</span>
        </template>
      </div>
      <div v-show="activeTab === 'coupon'" class="jf-activity-sixDiscount">
        <p class="txt" style="margin-bottom: 0.14rem">
          {{ `${cardCouponState.have_luck_discount_card ? "你已买卡" : "买卡后"}，` }}以下<span> {{ productIdList.length }} </span
          >款皮肤享专属券后价：
        </p>
        <div class="swiper-container--vip" style="padding-bottom: 0">
          <div class="swiper-wrapper">
            <swiper ref="swiperRef" :options="swiperOptin" class="swiper-wrapper">
              <swiper-slide v-for="(timeItem, index) in timeList" :key="index" class="swiper-slide">
                <div class="time-dot">
                  <span class="time">{{ timeItem.launchDateText }}</span>
                  <i class="dot dot--green"></i>
                </div>
                <div class="jf-goods-list">
                  <div v-for="(goods, idx) in timeItem.productIdList" :key="`${goods.amsId}_${idx}`">
                    <div class="goods-con">
                      <img class="movie-img" :src="goods.img" alt="" @click="goToPropPage(goods, index)" />
                    </div>
                    <p
                      v-if="!isHideCoupon && cardCouponState.have_luck_discount_card && haveDiscountCoupon(goods.couponId)"
                      class="txt"
                      @click="goToPropPage(goods, index)"
                    >
                      查看皮肤 >
                    </p>
                    <div
                      v-else-if="
                        !isHideCoupon &&
                        cardCouponState.have_luck_discount_card &&
                        cardCouponState.have_discount_coupons &&
                        !haveDiscountCoupon(goods.couponId) &&
                        isTimeValid(goods.couponId)
                      "
                      class="jf-Coupon-btn--bg"
                      @click="receiveDiscountCard(goods.couponId)"
                    >
                      <!-- 领取 -->
                    </div>
                    <p v-else class="txt">
                      省<span>{{ goods.discount }}</span
                      >点券
                    </p>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
      <div v-for="item in activityGoods" v-show="activeTab === item.name" :key="item.name" class="jf-activity-goods">
        <img :src="item.activityImg" alt="" @click="goActivity(item)" />
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent, reactive, computed, toRefs, onMounted } from "@vue/composition-api"
import useDetailItem from "../../mixins/useDetailItem"
import * as reportDict from "@constants/report-dictonary"
import * as url from "@utils/url"
import * as request from "@utils/request"
import * as helper from "@utils/helper"
import { checkTimeValid } from "@utils/helper"
import { swiper, swiperSlide } from "vue-awesome-swiper"

export default defineComponent({
  components: {
    swiper,
    swiperSlide
  },
  props: {
    shelfConfig: Object,
    cardId: String,
    cardCouponInfo: Object,
    isHideCoupon: Boolean,
    isShowTab: Boolean
  },
  emits: ["receiveDiscountCard"],
  setup(props, { root, emit }) {
    const { redirectPropDetail } = useDetailItem(root)

    const state = reactive({
      vmallConfigByAMSID: computed(() => root.$store.getters.vmallConfigByAMSID),
      // 皮肤预告list
      timeList: computed(() => {
        let timeList = props.shelfConfig?.activity60CardConfig?.timeList || []
        let list = timeList
          .map(item => {
            return {
              ...item,
              productIdList:
                item?.productIdList
                  ?.map(productId => {
                    let obj = url.getStrParams(productId, true)
                    let coupon = state.couponsInfo.find(item => item.skinid === obj.amsId) || ""
                    return { ...obj, couponId: coupon?.id || "" }
                  })
                  ?.sort((a, b) => a.order - b.order) || []
            }
          })
          ?.sort((a, b) => a.order - b.order)
        return list
      }),
      // 皮肤list
      productIdList: computed(() => {
        let list = []
        state.timeList.map(item => (list = [...list, ...item.productIdList]))
        return list
      }),
      // 返场活动
      activityGoods: computed(() => {
        return props.shelfConfig?.activity60CardConfig?.activityGoodsList || []
      }),
      // 60卡券地址
      coupons_info_location: computed(() => {
        let info = url.getStrParams(state.vmallConfigByAMSID[props?.cardId]?.goodsExtend?.["66cardInfo"] || "", true)
        return info.coupons_info_location || ""
      }),
      //60卡券信息
      couponsInfo: [],
      // 券状态
      cardCouponState: computed(() => props.cardCouponInfo || {}),
      isShowTabs: computed(() => {
        if (props.isShowTab) {
          return true
        }
        return false
      }),
      isLoading: false,
      bgImg: require("../../../../ui/assets/mobile/images/jf-activity-bg02.png"),
      swiperOptin: {
        slidesPerView: "auto",
        freeMode: true
      },
      swiperRef: null,
      activeTab: "coupon"
    })

    // 获取60卡专属券信息
    const get60CardCouponsInfo = async () => {
      if (state.coupons_info_location) {
        try {
          const results = await request.ajax({
            url: url.addGetParam({ timestamp: helper.getNowTimeStamp() }, state.coupons_info_location)
          })
          state.couponsInfo = results?.itemMap?.["66card"]?.coupons || []
        } catch (e) {
          console.log(e)
        }
      }
    }

    // 领券
    const receiveDiscountCard = couponId => {
      if (state.isLoading) {
        return
      }
      root.$store.dispatch("setLoadingStart")
      state.isLoading = true
      let coupon = state.couponsInfo.find(item => item.id === couponId) || ""
      coupon && emit("receiveDiscountCard", coupon, changeCouponState)
    }

    // 券状态
    const haveDiscountCoupon = couponId => {
      return state.cardCouponState?.have_discount_coupons?.[couponId]
    }

    // 领券后更新状态
    const changeCouponState = (id, flag) => {
      state.cardCouponState.have_discount_coupons[id] = flag
      state.isLoading = false
      root.$store.dispatch("setLoadingEnd")
    }

    // 券
    const isTimeValid = couponId => {
      let coupon = state.couponsInfo.find(item => item.id === couponId) || ""
      return checkTimeValid(coupon?.coupon_start_time, coupon?.coupon_end_time)
    }

    const slideTo = () => {
      const nowDate = helper.getNowTimeStamp()
      let list = state.timeList?.filter(item => {
        let launchDate = new Date(item?.launchDate).getTime()
        return launchDate && nowDate >= launchDate
      })
      state.swiperRef.swiper.slideTo(list.length - 1)
    }

    onMounted(() => {
      get60CardCouponsInfo()
      slideTo()
    })

    const goToPropPage = (prop, index) => {
      if (!checkTimeValid(prop.exposureStartTime, prop.exposureEndTime) || !prop?.amsId) {
        root.$store.dispatch("setToastMsg", "皮肤还未曝光哦！敬请期待~")
        return
      }
      let goods = state.vmallConfigByAMSID[prop?.amsId]
      if (!goods) {
        return
      }
      redirectPropDetail({
        prop: goods,
        pfStructure: `${props.shelfConfig.keyName}_${index + 1}`,
        reportIformat: reportDict.CLICK.SERVICEZONE_ADS_BANNER
      })
    }

    const goActivity = item => {
      if (item?.activityUrl) {
        location.href = item?.activityUrl
      }
    }

    return {
      ...toRefs(state),
      goToPropPage,
      receiveDiscountCard,
      haveDiscountCoupon,
      isTimeValid,
      goActivity
    }
  }
})
</script>
